import { extractData } from '@/models';
import api from '@/services/api';
import { AssetType, Blockchain, Currency } from '@/types/asset';

interface AssetResponse {
  id: string;
  name: string;
  decimals: number;
  blockchain: string;
  currency: string;
  network: string|undefined;
  type: AssetType|undefined;
}

export default {
  getAssetInfo() {
    return api()
      .get<{
        assets: AssetResponse[];
        currencies: Currency[];
        blockchains: Blockchain[];
      }>(__ASSET_JSON_PATH)
      .then(extractData);
  },
};
